import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import Loading from 'components/base/Loading';

import { SaveAndBackButtons } from '../../../components/base/BottomStepComponent';
import ContentSections from '../../../components/base/ContentSections';
import DeletePrompt from '../../../components/base/DeletePrompt';
import BasePrompt from '../../../components/base/prompt/BasePrompt';
import CreateMallStepOneContentSection from '../../../components/mall/CreateMallStepOneContentSection';
import {
  defaultPreviewImage,
  getPreviewLayoutImages,
} from '../../../components/store/StorePreviewConfig';
import {
  APIStatus,
  CheckStatus, // LanguageConfig,
  DELETE_RELATED_SECTIONS,
} from '../../../config/CustomEnums';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { createAction } from '../../../utils';

function CreateMallStepOne({ detail, checked, saved, languages }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const { watch, getValues, trigger } = useFormContext();

  const inputWithImageConfig = getPreviewLayoutImages();
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [activeSection, setActiveSection] = useState();
  const [showAlertPrompt, setShowAlertPrompt] = useState({
    title: 'brand',
    show: false,
    pathname: 'brand/create',
  });
  const [refreshDate, setRefreshDate] = useState(new Date());

  useEffect(() => {
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));
  }, [dispatch]);

  useEffect(() => {
    if (checked === CheckStatus.checkedWithSuccess) {
      dispatch(createAction('mall/createOrUpdate')({}));
    }
  }, [dispatch, checked]);

  useEffect(() => {
    if (
      saved === APIStatus.success &&
      history.location.pathname.includes('edit')
    ) {
      history.push('/mall');
    }
  }, [history, saved]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'mall/clearData' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const id = params.id;
  useEffect(() => {
    if (id) {
      dispatch(createAction('mall/getOneMall')({ id }));
    } else {
      dispatch({ type: 'mall/loadDataFromCookie' });
    }

    dispatch(createAction('mall/getDistrictList')({}));
  }, [dispatch, id, refreshDate]);

  const getTabs = (language, setActiveSection) => {
    const tabs = [
      <CreateMallStepOneContentSection
        language={language}
        languages={languages}
        onFocus={setActiveSection}
        setShowAlertPrompt={setShowAlertPrompt}
        refreshDate={refreshDate}
      />,
    ];
    return tabs;
  };

  if (saved === APIStatus.calling) {
    return <Loading />;
  }

  return (
    <>
      <ContentSections
        languageTabContent={{
          containers: languages?.map((item) => ({
            container: getTabs(item.code, setActiveSection),
            key: item.code,
            title: item.sourceName,
          })),
        }}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultPreviewImage()}
        activeSection={activeSection}
        hidePreview={false}
      />
      <SaveAndBackButtons
        saveTempText={params.id ? 'Delete' : null}
        saveText={params.id ? 'Update' : 'Save'}
        backAction={() => history.goBack()}
        saveAction={async () => {
          let isValid = await trigger(
            [
              'mallTranslations.en.name',
              // 'coverPhoto',
              // 'mallTranslations.en.address',
              // 'latitude',
              // 'longitude',
            ],
            { shouldFocus: true },
          );
          console.log('@83', isValid, getValues(), isValid);
          if (isValid) {
            dispatch(
              createAction('mall/createOrUpdate')({
                data: getValues(),
                afterActions: () => history.push({ pathname: '/mall' }),
              }),
            );
          }
        }}
        saveTempAction={() => setShowDeletePrompt(true)}
        tempRequires={PermissionCodes.deleteMall}
      />
      <DeletePrompt
        message={{
          title: 'Delete this Mall',
          content: 'Did you confirm to delete this Mall?',
        }}
        title={'Mall'}
        data={detail}
        relatedSections={[]}
        show={showDeletePrompt}
        onClose={() => {
          setShowDeletePrompt(false);
        }}
        onConfirm={() => {
          setShowDeletePrompt(false);
          dispatch({
            type: `mall/updateState`,
            payload: { checkedList: [detail] },
          });
          dispatch(
            createAction('mall/delete')({
              afterAction: () => {
                history.push('/mall');
              },
            }),
          );
        }}
      />
      <BasePrompt
        show={showAlertPrompt.show}
        closeAction={() =>
          setShowAlertPrompt({ ...showAlertPrompt, show: false })
        }
        leftButton={{
          text: 'Done and refresh',
          action: () => {
            setRefreshDate(new Date());
            setShowAlertPrompt({ ...showAlertPrompt, show: false });
          },
        }}
        rightButton={{
          text: `Go to create ${showAlertPrompt.title}`,
          action: () => {
            window.open(showAlertPrompt.pathname, '_blank');
          },
        }}
        title={`Go to create a ${showAlertPrompt.title}?`}
        description={`You will leave the mall creation process. After you create a new ${showAlertPrompt.title}, you can back to this page.`}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  detail: state.mall.detail || {},
  checked: state.mall.checked,
  errorFields: state.mall.errorFields,
  saved: state.mall.saved,
  languages: state.language.allList,
});

export default connect(mapPropsToState)(CreateMallStepOne);
